export default __webpack_public_path__ + "scene1_1_bga07342.png";